import { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { HumbeeTabs } from '../../MUI_custom_component';
import BenefitCard from './Components/BenefitCard';
import { getAllInsurances } from './APIs/action';
import { toast } from 'react-toastify';
import { trackAnalyticsEvent } from '../../../utils/clevertap';
import { useSelector } from 'react-redux';
import Entity from '../../../v3/Common/Entity';
import StickyEntity from '../../../v3/Common/Entity/StickyEntity';
import { MODULE_PERMISSION_ENUM } from '../../../v3/Sidebar/Enum';
import NoAccess from '../../../v3/Common/NoAccess/NoAccess';

const Benefits = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [insuranceData, setInsuranceData] = useState([]);
  const userData = useSelector(state => state.user?.userData);

  const {
    selectedSupplierData,
    selectedSupplier: selectedManufacturer,
    selectedEntity: selectedCompanyEntity,
    selectedEntityInfo,
  } = useSelector(
    (state) => state.entityReducer
  );
  const hasAccess = selectedEntityInfo?.has_access;

  const handleTabChange = (_, newValue) => {
    if (newValue !== null) {
      // Track tab change event
      trackAnalyticsEvent('BENEFICIARY_TAB_CHANGE', {
        manufacturer_id: userData?.manufacturer_id || '',
        tab_name: insuranceData[newValue]?.display_name || '',
        tab_index: newValue
      });
      
      setSelectedTab(newValue);
    }
  };

  const currentBenefits = insuranceData[selectedTab]?.benefits || [];
  const getAllInsuranceDetails = async () => {
      const { data, error, message } = await getAllInsurances(selectedCompanyEntity);
      if (!error) {
        setInsuranceData(data);
      } else {
        toast.error(message)
      }   
  };
  
  useEffect(() => {
    selectedCompanyEntity && hasAccess !== false && getAllInsuranceDetails(selectedCompanyEntity);
  }, [selectedCompanyEntity, hasAccess]);
  
  // Track benefits screen view
  useEffect(() => {
    trackAnalyticsEvent('BENEFICIARY_BENEFITS_SCREEN_VIEW', {
      manufacturer_id: userData?.manufacturer_id || '',
      user_id: userData?.id || ''
    });
  }, [userData?.manufacturer_id, userData?.id]);
  const isEntityEnabled = selectedSupplierData?.entity_enabled;
  return (
    <>
      <StickyEntity module_name={MODULE_PERMISSION_ENUM.BENEFICIARY} />
      {hasAccess === false ?(
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '60vh',
          }}
        >
          <NoAccess />
        </Box>
      ) : (
        <Box sx={{ mt: {xs : isEntityEnabled ? '96px': 0, md: 0 }, p: 2, display: 'flex', flexDirection: 'column', gap: { xs:1, md:2 } }}>
            <HumbeeTabs
              data={insuranceData}
              currentTab={selectedTab}
              onChange={(_, newValue) => {
                if (newValue !== null) handleTabChange(_, newValue);
              }}
              getTabLabel={(item) => item.display_name}
              getTabKey={(item) => item.display_name}
              tabType="dashed"
              tabsSx={{ mb: 3 }}
              renderTabContent={() => (
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  {currentBenefits.map((item, index) => (
                    <Grid item xs={12} md={6} key={index}>
                      <BenefitCard item={item} selectedCompanyEntity={selectedCompanyEntity} />
                    </Grid>
                  ))}
                </Grid>
              )}
            />
        </Box>
      )}
    </>
  );
};

export default Benefits;
